function key(programSlug) {
  return `epl_prog_${programSlug}_progress`;
}

export function getProgress(programSlug) {
  try {
    return JSON.parse(localStorage.getItem(key(programSlug)) || "{}");
  } catch {
    return {};
  }
}

export function setUnitCompleted(programSlug, unitSlug, payload = {}) {
  const p = getProgress(programSlug);
  p[unitSlug] = {
    ...(p[unitSlug] || {}),
    completedAt: Date.now(),
    ...payload,
  };
  localStorage.setItem(key(programSlug), JSON.stringify(p));
  return p;
}

/**
 * Verifica si todas las unidades de un programa están completadas
 * @param {string} programSlug - Identificador del programa
 * @param {number} totalUnits - Número total de unidades en el programa
 * @returns {boolean} true si todas las unidades están completas
 */
export function isProgramCompleted(programSlug, totalUnits) {
  const p = getProgress(programSlug);
  const completedUnits = Object.values(p).filter(unit => unit.completedAt).length;
  return completedUnits >= totalUnits;
}
